import React, { useCallback, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { message } from 'antd';

import { ContainerStyled, TitleStyled } from './styled';
import Loading from '$app/shared/components/Loading';

import ProductEditTabs from '../ProductEditTabs';
import {
  deleteProduct,
  fetchCatalogIdsBySku,
  fetchCatalogs,
  fetchProducts,
  getErrorMessage,
  updateProduct,
} from '../../productApi';

function ProductEditPage({ history, isNew, match, tabKey }) {
  const { sku } = match.params;
  const [loading, setLoading] = useState(true);
  const [operation, setOperation] = useState(null);
  const [catalogs, setCatalogs] = useState([]);
  const [operationCatalogs, setOperationCatalogs] = useState([]);

  const loadProductData = useCallback(async () => {
    setLoading(true);

    try {
      const [operations, nextCatalogs, nextOperationCatalogs] = await Promise.all([
        fetchProducts(),
        fetchCatalogs(),
        fetchCatalogIdsBySku(sku),
      ]);
      const nextOperation = operations.find((product) => product.sku === sku) || null;

      setOperation(nextOperation);
      setCatalogs(nextCatalogs);
      setOperationCatalogs(nextOperationCatalogs);
    } catch (error) {
      message.error(getErrorMessage(error));
      setOperation(null);
      setCatalogs([]);
      setOperationCatalogs([]);
    } finally {
      setLoading(false);
    }
  }, [sku]);

  useEffect(() => {
    loadProductData();
  }, [loadProductData]);

  if (loading) {
    return <Loading />;
  }

  if (!operation) {
    return 'Product not found.';
  }

  return (
    <ContainerStyled style={{ margin: '20px' }}>
      <Link to="/">Back to the list</Link>
      <TitleStyled>Edit Product</TitleStyled>
      <ProductEditTabs
        tabKey={tabKey}
        isNew={isNew}
        onSave={async (payload) => {
          const nextProduct = {
            ...payload.product,
          };

          delete nextProduct.market_price;
          delete nextProduct.fixed_cost;

          try {
            message.info('Saving your product changes...');
            await updateProduct({
              product: nextProduct,
              catalogs: payload.catalogs,
            });
            message.success('Product saved');
            await loadProductData();
          } catch (error) {
            message.error(getErrorMessage(error));
          }
        }}
        onDelete={async (productSku) => {
          try {
            await deleteProduct(productSku);
            message.success('Product deleted');
            history.push('../../');
          } catch (error) {
            message.error(getErrorMessage(error));
          }
        }}
        operation={operation}
        operationCatalogs={operationCatalogs}
        catalogs={catalogs}
      />
    </ContainerStyled>
  );
}

export default withRouter(ProductEditPage);
